import { useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

export function useCheckCallRoute() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/call") {
      const callEnded = localStorage.getItem("callEnded");
      if (callEnded === "true") {
        navigate("/", { replace: true });
      }
    }
  }, [navigate, window.location.pathname]);
}
